var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtoZ(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    className: "AtoZ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u043F\u043E \u0430\u043B\u0444\u0430\u0432\u0438\u0442\u0443") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.648 10.937a1 1 0 0 0 1.289-.585L3.443 9h3.114l.506 1.352A1 1 0 0 0 8 11a1.038 1.038 0 0 0 .352-.063 1 1 0 0 0 .585-1.289l-3-8a1 1 0 0 0-1.874 0l-3 8a1 1 0 0 0 .585 1.289ZM5 4.848 5.807 7H4.193ZM8 21H4l4.8-6.4A1 1 0 0 0 8 13H2a1 1 0 0 0 0 2h4l-4.8 6.4A1 1 0 0 0 2 23h6a1 1 0 0 0 0-2ZM13 13a1 1 0 0 0 2 0V4.414l2.293 2.293a1 1 0 0 0 1.414-1.414l-4-4a.99.99 0 0 0-.326-.217 1 1 0 0 0-.764 0 .99.99 0 0 0-.326.217l-4 4a1 1 0 0 0 1.414 1.414L13 4.414Z",
    fill: "#000000",
    className: "AtoZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.707 17.293a1 1 0 0 0-1.414 0L19 19.586V10a1 1 0 0 0-2 0v9.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.416 0l4-4a1 1 0 0 0-.002-1.414Z",
    fill: "#000000",
    className: "AtoZ"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtoZ);
export default __webpack_public_path__ + "static/media/AtoZ.4f03def8a22ad29ac58760f4e6ae4cb8.svg";
export { ForwardRef as ReactComponent };